import React from "react";
import whatsappIcon from "../static files/images/whatsapp.png";

const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/502562211"
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-button"
    >
      <img src={whatsappIcon} alt="WhatsApp" />
      <h1>Whatsapp</h1>
    </a>
  );
};

export default WhatsAppButton;
